// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"cf77ab17","310":"87cf03b7","380":"58dddad9","541":"1c88474c","796":"c7470e77"}[chunkId] + ".chunk.js";
};